import { ActiveSubscriptionStatuses, PlatformUser, SubscriptionPlan } from 'models/user'
import { UserIsAuth0User, UserIsPlatformUserClient } from 'utils/typeguards'

import { Auth0User } from 'models/auth'
import { Userpilot } from 'userpilot'
import { getRolesFromUser } from 'utils/auth'

export const USERPILOT_ID = process.env.REACT_APP_USERPILOT_ID

/** Type used for intercom configuration */
export type trackUserInterface = {
  user_id: string | undefined
  email: string | undefined
  name: string | undefined
  country: string
  language: string
  roles?: string
  subscribedWorkspaceIDs?: string
}

// Initialize Userpilot
export const initUserpilot = () => {
  if (USERPILOT_ID) {
    Userpilot.initialize(USERPILOT_ID)
  }
}

export const trackUserpilot = (user: Auth0User | PlatformUser) => {
  if (!user) return

  const trackUser: trackUserInterface = {
    user_id: user.email,
    email: user.email,
    name: user.name,
    country: user.country,
    language: user.language,
  }

  if (UserIsAuth0User(user)) {
    const roles = getRolesFromUser(user)
    const rolesString = Array.from(roles.all.values()).join(', ')
    trackUser['roles'] = rolesString
  } else {
    if (UserIsPlatformUserClient(user)) {
      const { workspaces } = user
      const nonPersonalWorkspaces = workspaces.filter(workspace => workspace.plan !== SubscriptionPlan.PERSONAL)
      const subscribedWorkspaces = nonPersonalWorkspaces.filter(workspace => ActiveSubscriptionStatuses.has(workspace.status))
      const subscribedWorkspacesIds = subscribedWorkspaces.map(workspace => workspace.id).join(',')
      trackUser['subscribedWorkspaceIDs'] = subscribedWorkspacesIds
    }
  }

  Userpilot.identify(
    user.id,
    trackUser
  )
}
